up.compiler(".up_manageshow", function () {
  document.querySelector(".html")?.classList.add("h-full");
  document.querySelector(".body")?.classList.add("h-full");
  document.querySelector(".main")?.classList.add("h-full");

  return () => {
    document.querySelector(".html")?.classList.remove("h-full");
    document.querySelector(".body")?.classList.remove("h-full");
    document.querySelector(".main")?.classList.remove("h-full");
  };
});
